<div class="it-pane">
	<div class="it-panehead">
		<div class="it-panehead-left">
			<span class="it-smalllabel">Body</span>
		</div>

		<div class="it-panehead-right">
			<div class="it-body-actions">
				<dx-select-box class="it-bodytype-dd" [items]="bodyTypes" displayExpr="label" valueExpr="value" [value]="request.bodyType" (onValueChanged)="updateRequest.emit({ bodyType: $event.value })">
				</dx-select-box>

				<button class="it-toolbtn" type="button" (click)="toggleBodyEdit()">
          {{ isBodyEditing ? 'Lock' : 'Edit' }}
        </button>

				<button class="it-toolbtn" type="button" (click)="formatBody.emit()" [disabled]="!isBodyEditing">
          Beautify
        </button>

				<button class="it-toolbtn" type="button" (click)="clearBody.emit()" [disabled]="!(request.body || '').length">
          Clear
        </button>
			</div>
		</div>
	</div>

	<it-body-editor *ngIf="isBodyEditing; else lockedPreview" [value]="request.body" (valueChange)="updateRequest.emit({ body: $event })">
	</it-body-editor>

	<ng-template #lockedPreview>
		<ng-container *ngIf="(request.body || '').length; else emptyBodyPreview">
			<ng-container *ngIf="isJsonLike(request.body); else maybeXmlLocked">
				<div class="it-pre it-pre-dark" [innerHTML]="(request.body | prettyjson:[true,3]) | trustHtml">
				</div>
			</ng-container>

			<ng-template #maybeXmlLocked>
				<ng-container *ngIf="isXmlLike(request.body); else rawLocked">
					<div class="it-pre it-pre-dark" [innerHTML]="(request.body | prettyxml:[true,2]) | trustHtml">
					</div>
				</ng-container>
			</ng-template>

			<ng-template #rawLocked>
				<pre class="it-pre it-pre-dark">{{ request.body }}</pre>
			</ng-template>
		</ng-container>

		<ng-template #emptyBodyPreview>
			<div class="it-empty">No body.</div>
		</ng-template>
	</ng-template>
</div>
